import React from 'react';

import styles from './UseLoose.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { useAxios } from '../../../../../../AxiosHandler';
import { useAuth } from '../../../../../../Auth';
import LineGraphCard from '../../../Cards/LineGraphCard/LineGraphCard';
import OffLeashPrizeCountGraph from './OffLeashPrizeCountGraph/OffLeashPrizeCountGraph';

function UseLoose(props: UseLooseProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = React.useState<any>();

    const options = {
        scales: {
            y: {
                suggestedMin: 0,
                suggestedMax: 10
            }
        },
        plugins: {
            legend: {
                display: false
            }
        }
    };

    function getData() {
        if (auth.selectedBreed == undefined) return;

        const requests = [
            {
                method: 'get',
                url: "/api/statistics/use/loose/" + auth.selectedBreed + "/ebv",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            },
            {
                method: 'get',
                url: "/api/statistics/use/loose/" + auth.selectedBreed + "/phenotype",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            },
            {
                method: 'get',
                url: "/api/statistics/use/loose/" + auth.selectedBreed + "/tests",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            }
        ];
        Promise.all(requests.map((request) => axios.single(request))).then((res) => {
            if (res[0].data?.length > 0 || res[1].data?.length > 0 || res[2].data?.length > 0) {

                setData({
                    fenotype: {
                        sumpoints: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.SUM_POINTS)
                        },
                        M1: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M1)
                        },
                        M2: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M2)
                        },
                        M3: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M3)
                        },
                        M4: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M4)
                        },
                        M5: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M5)
                        },
                        M6: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M6)
                        },
                        M7: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M7)
                        },
                        M8: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M8)
                        },
                        M9: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M9)
                        },
                        M10: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M10)
                        },
                        M10A: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M10A)
                        },
                        M10B: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M10B)
                        },
                        M10C: {
                            labels: res[1].data.map((item: any) => item.YEAR),
                            data: res[1].data.map((item: any) => item.M10C)
                        }
                    },
                    avlsverdi: {
                        sumpoints: {
                            labels: res[2].data.map((item: any) => item.YEAR),
                            data: {
                                numdogs: res[2].data.map((item: any) => item.ANT_HUNDER),
                                numtests: res[2].data.map((item: any) => item.ANT_PROVER),
                                numfirsts: res[2].data.map((item: any) => item.ANT_FORSTEPREMIER)
                            }
                        },
                        M1: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M1)
                        },
                        M2: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M2)
                        },
                        M3: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M3)
                        },
                        M4: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M4)
                        },
                        M5: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M5)
                        },
                        M6: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M6)
                        },
                        M7: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M7)
                        },
                        M8: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M8)
                        },
                        M9: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M9)
                        },
                        M10: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M10)
                        },
                        M10A: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M10A)
                        },
                        M10B: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M10B)
                        },
                        M10C: {
                            labels: res[0].data.map((item: any) => item.YEAR),
                            data: res[0].data.map((item: any) => item.AVERAGE_M10C)
                        }
                    }
                });


                props.onDataLoaded?.(true);
            } else {
                setData(undefined);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    React.useEffect(() => {
        if (auth.selectedBreed != undefined) {
            props.onDataLoaded?.(false);
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticsuseloose}>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.sumpoints.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.sumpoints.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.sumpoints.graph.title")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.sumpoints.labels,
                                datasets: [
                                    {
                                        label: t("statistics.areas.use.leash.info.graph.numdogs"),
                                        backgroundColor: "transparent",
                                        pointBackgroundColor: "#68DB5A",
                                        borderColor: "#68DB5A",
                                        pointRadius: 2,
                                        data: data?.avlsverdi.sumpoints.data.numdogs,
                                        tension: 0.3
                                    },
                                    {
                                        label: t("statistics.areas.use.leash.info.graph.numtests"),
                                        backgroundColor: "transparent",
                                        pointBackgroundColor: "#DB5A5A",
                                        borderColor: "#DB5A5A",
                                        pointRadius: 2,
                                        data: data?.avlsverdi.sumpoints.data.numtests,
                                        tension: 0.3
                                    },
                                    {
                                        label: t("statistics.areas.use.leash.info.graph.numfirsts"),
                                        backgroundColor: "transparent",
                                        pointBackgroundColor: "#5A6ADB",
                                        borderColor: "#5A6ADB",
                                        pointRadius: 2,
                                        data: data?.avlsverdi.sumpoints.data.numfirsts,
                                        tension: 0.3
                                    }
                                ]
                            }}
                            options={{
                                scales: {
                                    y: {
                                        suggestedMin: 0,
                                        suggestedMax: 100
                                    }
                                },
                                plugins: {
                                    legend: {
                                        display: true
                                    }
                                }
                            }}
                            title={t("statistics.areas.use.leash.info.graph.title")}
                        />

                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <OffLeashPrizeCountGraph
                            
                        />
                    </Col>
                </Row>
            </Container>
            <hr/>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col sm="12" md="6" className={styles.col}>
                        <h3>{t("statistics.areas.use.loose.fenotype.title")}</h3>

                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M1.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M1.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M1.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M2.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M2.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M2.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M3.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M3.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M3.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M4.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M4.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M4.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M5.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M5.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M5.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M6.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M6.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M6.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M7.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M7.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M7.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M8.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M8.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M8.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M9.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M9.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M9.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M10.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M10.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M10.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M10A.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M10A.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M10A.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M10B.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M10B.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M10B.graph.title")}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.fenotype.M10C.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.fenotype.M10C.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.loose.fenotype.M10C.graph.title")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                    <h3>{t("statistics.areas.use.loose.avlsverdi.title")}</h3>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M1.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M1.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M2.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M2.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M3.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M3.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M4.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M4.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M5.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M5.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M6.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M6.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M7.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M7.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M8.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M8.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M9.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M9.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M10.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M10.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M10A.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M10A.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M10B.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M10B.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                        <hr/>
                        <LineGraphCard
                            data={{
                                labels: data?.avlsverdi.M10C.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avlsverdi.M10C.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={" "}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

class UseLooseProps {
    onDataLoaded?: (hasData: boolean) => void;
}

export default UseLoose;